import axios from 'axios';

function getBaseURL() {
  const gespeichert = localStorage.getItem('portal_server_url');
  if (gespeichert) return gespeichert;
  if (process.env.NODE_ENV === 'development') return 'http://127.0.0.1:9000';
  return window.location.origin;
}

const API = axios.create({ baseURL: getBaseURL() });

API.interceptors.request.use((config) => {
  const token = localStorage.getItem('portal_token');
  if (token) config.headers.Authorization = `Bearer ${token}`;
  return config;
});

API.interceptors.response.use(
  (response) => response,
  (error) => {
    // Eine falsche Anmeldung ist auch ein 401 - dort nicht umleiten
    if (error.response?.status === 401 && !error.config?.url?.includes('/admin/login')) {
      localStorage.removeItem('portal_token');
      window.location.hash = '#/login';
    }
    return Promise.reject(error);
  }
);

// Auth und Portal-Benutzer
export const login = (email, passwort) => API.post('/admin/login', { email, passwort });
export const ich = () => API.get('/admin/ich');
export const eigenesPasswortAendern = (altes_passwort, neues_passwort) =>
  API.post('/admin/ich/passwort', { altes_passwort, neues_passwort });
export const benutzerListe = () => API.get('/admin/benutzer');
export const benutzerAnlegen = (daten) => API.post('/admin/benutzer', daten);
export const benutzerPasswortSetzen = (id, neues_passwort) => API.post(`/admin/benutzer/${id}/passwort`, { neues_passwort });
export const benutzerLoeschen = (id) => API.delete(`/admin/benutzer/${id}`);

// Uebersicht, Protokoll, Einstellungen
export const uebersicht = () => API.get('/admin/uebersicht');
export const protokollListe = (limit = 500) => API.get('/admin/protokoll', { params: { limit } });
export const einstellungenLesen = () => API.get('/admin/einstellungen');
export const einstellungenSpeichern = (daten) => API.put('/admin/einstellungen', daten);
export const testmail = (an) => API.post('/admin/einstellungen/testmail', { an });
export const anfrageErledigen = (id) => API.post(`/admin/anfragen/${id}/erledigt`);
export const anfrageZuordnen = (id, kunde_id) => API.post(`/admin/anfragen/${id}/zuordnen`, { kunde_id });

// Kunden
export const kundenListe = () => API.get('/admin/kunden');
export const kundenAkte = (id) => API.get(`/admin/kunden/${id}`);
export const kundeErstellen = (daten) => API.post('/admin/kunden', daten);
export const kundeAendern = (id, daten) => API.put(`/admin/kunden/${id}`, daten);
export const kundeLoeschen = (id) => API.delete(`/admin/kunden/${id}`);

// Lizenzen. Nach jeder Aenderung signiert das Portal den Key neu; die
// Kundeninstallation uebernimmt ihn beim naechsten Checkin von selbst.
export const modulListe = () => API.get('/admin/lizenzen/module');
export const lizenzErstellen = (daten) => API.post('/admin/lizenzen', daten);
export const lizenzLoeschen = (id) => API.delete(`/admin/lizenzen/${id}`);
export const lizenzVerlaengern = (id, gueltig_bis) => API.post(`/admin/lizenzen/${id}/verlaengern`, { gueltig_bis });
export const lizenzKontingent = (id, max_arbeitsplaetze, max_mandanten) =>
  API.post(`/admin/lizenzen/${id}/kontingent`, { max_arbeitsplaetze, max_mandanten });
export const lizenzModule = (id, module) => API.post(`/admin/lizenzen/${id}/module`, { module });
export const lizenzKeyErzeugen = (id, hardware_id, ohne_bindung = false) =>
  API.post(`/admin/lizenzen/${id}/key`, { hardware_id: hardware_id || null, ohne_bindung });
export const lizenzGeraetWechseln = (id, hardware_id) => API.post(`/admin/lizenzen/${id}/geraet`, { hardware_id: hardware_id || null });
export const lizenzSperren = (id, grund, ab) => API.post(`/admin/lizenzen/${id}/sperren`, { grund, ab: ab || null });
export const lizenzEntsperren = (id) => API.post(`/admin/lizenzen/${id}/entsperren`);

// Installationen
export const installationenListe = () => API.get('/admin/installationen');
export const installationEntfernen = (id) => API.delete(`/admin/installationen/${id}`);

// Releases
export const releasesListe = () => API.get('/admin/releases');
export const releaseHochladen = (formData, onFortschritt) =>
  API.post('/admin/releases', formData, {
    headers: { 'Content-Type': 'multipart/form-data' },
    onUploadProgress: (e) => { if (onFortschritt && e.total) onFortschritt(Math.round((e.loaded / e.total) * 100)); },
  });
export const releaseAendern = (id, changelog) => API.put(`/admin/releases/${id}`, { changelog });
export const releaseFreigeben = (id) => API.post(`/admin/releases/${id}/freigeben`);
export const releaseNurTest = (id) => API.post(`/admin/releases/${id}/test`);
export const releaseZurueckziehen = (id) => API.post(`/admin/releases/${id}/zurueckziehen`);
export const releaseLoeschen = (id) => API.delete(`/admin/releases/${id}`);

// Oeffentlich (ohne Anmeldung)
export const aktivieren = (daten) => API.post('/aktivierung', daten);
export const kontakt = () => API.get('/kontakt');
export const verlaengerungAnfragen = (daten) => API.post('/verlaengerung/anfrage', daten);

export default API;
